import React from "react";
import { compact } from "lodash";
import { Location } from "../Location";
import { AccommodationEditor } from "../../accommodations/AccommodationEditor/AccommodationEditor";
import { FormData } from "../../accommodations/AccommodationEditor/utils";

interface Params {
  accommodationId: string;
}

export class AccommodationEditorLocation extends Location<Params> {
  constructor(accommodationId?: string, private initialValues?: Partial<FormData>) {
    super({ accommodationId });
  }

  render() {
    return (
      <AccommodationEditor
        id={this.params.accommodationId}
        initialData={this.initialValues}
        onClose={this.navigation.close}
      />
    );
  }

  toURI() {
    const { accommodationId } = this.params;
    const parts = compact([
      "/accommodations",
      accommodationId || "new",
      accommodationId && "edit"
    ]);
    return parts.join("/");
  }
}
